import instance from '../index';

const RES_DASHBOARD = 'synthetic-dashboard';

export const DashboardApi = {
  getData({ payload }) {
    return instance.post(`${RES_DASHBOARD}`, payload);
  }
};
